import { createSlice } from '@reduxjs/toolkit';

const locationSlice = createSlice({
  name: 'location',
  initialState: {
    settings: {},
    loading: false,
  },
  reducers: {
    updateSettings: (state, action) => {
      state.settings = action.payload;
      state.loading = false;
    },
    requestLocation: (state) => {
      state.loading = true;
    },
    updateCostCenterData: (state, action) => {
      state.costCenterData = action.payload;
      state.loading = false;
    },
  },
});

export default locationSlice;
